export const REGIONS = {
    BA: {short: 'BA', center: {lat: 44.2, lng: 17.8}},
    CAR: {short: 'CF', center: {lat: 6.611111, lng: 20.939444}},
    NG: {short: 'NG', center: {lat: 9.082, lng: 8.6753}},
    TJ: {short: 'TJ', center: {lat: 38.861, lng: 71.2761}},
} as const;
